const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Devedores/Search')
const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Devedores/Single')

export default [
  {
    path: 'devedores',
    name: 'DevedoresSearch',
    component: Search,
    meta: {
      title: 'Inadimplentes',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'devedores',
        action: 'read'
      }
    }
  },
  {
    path: 'devedores/:id',
    name: 'DevedoresEdit',
    component: Single,
    meta: {
      title: 'Inadimplente',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'devedores',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/devedores.js